import React, { useState } from "react";
import { Box, TextField, Button, Typography, CircularProgress } from "@mui/material";

const GuestBookingSearch = ({ setEnableSearch, enableSearch, setDataOne, dataOne, setLoading, loading }) => {
    const [inputValue, setInputValue] = useState("");
    const [error, setError] = useState(false);

    // ✅ Email Validation Function
    const validateEmail = (email) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        if (!validateEmail(inputValue)) {
            setError(true); // ✅ Show error if email is invalid
            return;
        }

        setLoading(true);
        setError(false);

        // Update email only if it's different
        if (dataOne.email !== inputValue) {
            setDataOne((prev) => ({ ...prev, email: inputValue }));
        }

        // Delay for better user experience
        setTimeout(() => {
            setEnableSearch(true); // Enable search
            setLoading(false); // Stop loading after timeout
        }, 1000);
    };

    const handleInputChange = (event) => {
        setInputValue(event.target.value);
        setError(false); // ✅ Reset error when user starts typing
    };

    return (
        <Box
            sx={{
                p: 4,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                marginTop: { md: '10%' }
            }}
        >
            {/* Title */}
            <Typography variant="h4" sx={{ fontWeight: "bold", mb: 2 }}>
                Find all your reservations in one place!
            </Typography>
            <Typography variant="body1" sx={{ color: "#64748B", mb: 4 }}>
                Enter your email to access your past and upcoming bookings.
            </Typography>

            {/* Search Box */}
            <Box sx={{ display: "flex", gap: 1, width: "100%", maxWidth: 400 }}>
                <TextField
                    fullWidth
                    label="Guest email"
                    placeholder="Enter your email address"
                    variant="outlined"
                    size="small"
                    type="email"
                    value={inputValue}
                    onChange={handleInputChange}
                    error={error} // ✅ Show red border if error
                    helperText={error ? "Please enter a valid email address" : ""}
                    sx={{
                        "& label": { color: "#697488" }, // Label color
                        "& label.Mui-focused": { color: "#697488" }, // Label color when focused
                        "& .MuiOutlinedInput-root": {
                            "& fieldset": { borderColor: error ? "red" : "#dddddd" }, // ✅ Show red border if invalid
                            "&:hover fieldset": { borderColor: "#dddddd" }, // Border color on hover
                            "&.Mui-focused fieldset": { borderColor: error ? "red" : "#dddddd" } // Border color when focused
                        },
                    }}
                />

                {loading ? (
                    <Button
                        variant="contained"
                        sx={{
                            minWidth: "120px",
                            height: "40px",
                            backgroundColor: "#6dc8bf",
                            color: "white",
                            "&:hover": { backgroundColor: "#5bb8ae" },
                        }}
                        disabled
                    >
                        <CircularProgress sx={{ color: "white" }} size={20} />
                    </Button>
                ) : (
                    <Button
                        variant="contained"
                        sx={{
                            minWidth: "120px", // ✅ Ensures consistent width
                            height: "40px", // ✅ Matches input field height
                            backgroundColor: "#6dc8bf", // ✅ Custom background color
                            color: "white",
                            fontSize: "14px",
                            fontWeight: "bold",
                            borderRadius: "8px",
                            textTransform: "none",
                            "&:hover": { backgroundColor: "#5bb8ae" },
                        }}
                        onClick={handleSubmit}
                        disabled={!inputValue || error} // ✅ Disable if input is empty or invalid
                    >
                        Search
                    </Button>
                )}
            </Box>
        </Box>
    );
};

export default GuestBookingSearch;
